import { render, staticRenderFns } from "./modalAddNewDocumentation.vue?vue&type=template&id=7d6cdd48&"
import script from "./modalAddNewDocumentation.vue?vue&type=script&lang=js&"
export * from "./modalAddNewDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports